export default {"src":"/_next/static/media/VNFlag.fa3e6533.svg","height":18,"width":24};